const marinaArray = [
  { id: 1, title: "Brixham", image: "brixham.jpg", href: "brixham_marina" },
  { id: 2, title: "Cobb's Quay", image: "cobbs.jpg", href: "cobbs_quay_marina" },
  { id: 3, title: "Hythe", image: "hythe.jpg", href: "hythe_marina_village" },
  { id: 4, title: "Mercury", image: "mercury.jpg", href: "mercury_yacht_harbour" },
  { id: 5, title: "Northney", image: "northney.jpg", href: "northney_marina" },
  { id: 6, title: "Ocean Village", image: "oceanvillage.jpg", href: "ocean_village_marina" },
  { id: 7, title: "Penton Hook", image: "penton.jpg", href: "penton_hook_marina" },
  { id: 8, title: "Torquay", image: "torquay.jpg", href: "torquay_marina" },
];

export default marinaArray;
